<template>
  <v-dialog v-model="dialog" scrollable width="1000" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="pt-4 card">
      <v-layout class="flex-column flex-sm-row">
        <v-flex>
          <student-filter @onFilterChanged="searchStudent"></student-filter>
        </v-flex>
        <v-flex xs12 sm9 md9>
          <v-data-table
            dense
            show-select
            v-model="selected"
            :headers="headers"
            :items="activeStudents"
            :disable-pagination="true"
            :hide-default-footer="true"
          >
            <!-- :items-per-page="10" -->
            <v-layout slot="top" class="px-2 px-sm-0">
              <v-flex xs12 sm8 md8 class="mb-2">
                <div class="flex-center">
                  <v-btn
                    small
                    class="mr-2"
                    depressed
                    @click="addStudentToClass"
                    :disabled="selected.length === 0"
                    :loading="loading"
                  >
                    <v-icon left>add</v-icon>Thêm Vào Lớp
                  </v-btn>
                </div>
              </v-flex>
              <v-flex xs12 sm4 md4 class="d-flex flex-row-reverse">
                <!-- <drop-menu></drop-menu> -->
              </v-flex>
            </v-layout>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip v-if="item.status" small label dark :color="getColor(item.status)">{{
                item.status | getStatus
              }}</v-chip>
            </template>
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox
                :value="isSelected"
                :readonly="item.disabled"
                :disabled="item.disabled"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { Student } from '@/plugins/api'
import StudentFilter from '@/modules/class/student/StudentFilter.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    StudentFilter
  },
  props: {
    lastSelectedStudents: Array,
    state: Boolean
  },
  data() {
    return {
      loading: false,
      dialog: false,
      searchResults: [],
      students: [],
      selected: [],
      headers: [
        {
          text: 'Tên',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Mã', value: 'code' },
        { text: 'Nhóm', value: 'tags' },
        { text: 'Email', value: 'email' },
        { text: 'Số điện thoại', value: 'phone' },
        { text: 'Trạng thái', value: 'status' }
      ]
    }
  },
  computed: {
    ...mapGetters('classDetail', ['classData']),
    activeStudents() {
      return this.students.map(student => ({
        ...student,
        disabled: student.status !== 'active'
      }))
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateClass']),
    getColor(status) {
      if (status === 'active') return 'green'
      if (status === 'reserved') return 'orange'
      else return 'gray'
    },
    async searchStudent(filter) {
      this.selected = []
      this.students = await Student.fetch({
        ...filter,
        status: 'active',
        id_nin: this.lastSelectedStudents.map(s => s.id)
      })
    },
    async addStudentToClass() {
      this.loading = true
      await this.updateClass({
        id: this.classData.id,
        students: [...new Set([...this.classData.students, ...this.selected.map(s => s.id)])]
      })
      this.loading = false
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.selectedStudents = []
      this.dialog = true
    }
  },
  filters: {
    getStatus(status) {
      if (status === 'reserved') return 'Bảo Lưu'
      if (status === 'active') return 'Hoạt Động'
      if (status === 'deactive') return 'Thôi học'
      return status
    }
  }
}
</script>
<style scoped>
.card {
  height: 100%;
}
</style>
